import React, { useEffect, useMemo } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./LivraisonMedicamentsPage.css";
import { useLanguage } from '../i18n/LanguageContext';

const LivraisonMedicamentsPage = () => {
  const MySwal = useMemo(() => withReactContent(Swal), []);
  const { t } = useLanguage();

  useEffect(() => {
    MySwal.fire({
      title: t('servicesPages.pharmacyComingSoonTitle'),
      text: `🚧 ${t('servicesPages.pharmacyComingSoonBody')}`,
      icon: "info",
      confirmButtonText: "OK",
    });
  }, [MySwal, t]);

  return (
    <div className="livraison-page">
      <Container fluid className="py-5 px-4">
        <Row className="align-items-center">
          <Col md={6} className="mb-4">
            <h6 className="text-uppercase text-primary mb-2">{t('servicesPages.label')}</h6>
            <h2 className="mb-4">{t('servicesPages.pharmacyTitle')}</h2>
            <p className="text-muted">{t('servicesPages.pharmacyBody1')}</p>
            <p className="text-muted">{t('servicesPages.pharmacyBody2')}</p>
            <p className="text-muted">{t('servicesPages.pharmacyBody3')}</p>
            <Button variant="primary" className="btn-blue">
              {t('servicesPages.pharmacyCta')} &nbsp; +
            </Button>
          </Col>

          <Col md={6} className="position-relative">
            <div className="image-wrapper">
              <img
                src="/images/Livraison-De-Medicaments.webp"
                alt="Livraison médicaments"
                className="img-fluid shadow rounded"
              />
              <div className="purple-bar"></div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LivraisonMedicamentsPage;
